import { CheckOutlined } from '@ant-design/icons';
import type { TrainingActivity } from '@/types/training';
import { Card } from 'antd';

interface BenefitsCardProps {
  activity: TrainingActivity;
}

export function BenefitsCard({ activity }: BenefitsCardProps) {
  if (!activity.enrichment?.length) return null;

  return (
    <Card title='Benefits'>
      <div className='space-y-2'>
        {activity.enrichment?.map((benefit, index) => (
          <div key={index} className='flex items-start gap-2'>
            <div className='flex-shrink-0 w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mt-0.5'>
              <CheckOutlined className='text-xs text-green-700' />
            </div>
            <p className='text-sm'>{benefit}</p>
          </div>
        ))}
      </div>
    </Card>
  );
}

